import React, { useContext, useEffect, useState } from 'react';
import Toast from 'monday-ui-react-core/dist/Toast';
import { FileContext } from '../../context/FileContext';
import { useTranslation } from 'react-i18next';

const CustomToast = () => {
  const { toastMessage, triggerToast } = useContext(FileContext);
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (toastMessage) {
      setShowToast(true);
    }
  }, [toastMessage]);

  const handleClose = () => {
    setShowToast(false);
    triggerToast(null);
  };

  return (
    <Toast
      className="monday-storybook-toast_wrapper"
      open={showToast}
      autoHideDuration={3000}
      type={Toast.types.NEGATIVE}
      onClose={handleClose}
    >
      {t(toastMessage)}
    </Toast>
  );
};

export default CustomToast;
